import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import styles from './Items.css'
import {formValueSelector, arrayPush, change} from 'redux-form'
import {
  taxAssignToItemItemsRequest,
  taxAssignToItemSelectAllNone,
  taxAssignToItemToggleOne,
  checkSelectAllTaxItems,
  uncheckSelectAllTaxItems,
  cancelTaxAssignToItem
} from 'actions/library/tax'
import _intersection from 'lodash/intersection'
import _map from 'lodash/map'

class Items extends React.Component {
  componentWillMount () {
    this._allChecked(true)
  }

  render () {
    const {items} = this.props
    if (items.length > 0) {
      return (<div>
        <div className={`row ${styles['row-wrapper-first']}`}>
          <div className={`col-xs-7 ${styles['item-assign-all-result-header']}`}>
            {this._itemsAssigned()} items assigned
          </div>
          <div className={`col-xs-1 ${styles['item-assign-all-result-header']}`} />
          <div className={`col-xs-4 ${styles['item-checkbox-header']}`}>
            {
              this.props.checkSelectAllTaxItemsFlag ? <a href='#' onClick={(e) => this._selectAllNone(e, false)}>Deselect All</a>
                : <a href='#' onClick={(e) => this._selectAllNone(e, true)}>Select All</a>
              // <input type='checkbox' checked={this.props.checkSelectAllTaxItemsFlag} onChange={(e) => this._selectAllNone(e, e.target.checked)} />
            }
          </div>
        </div>

        <div className={styles.wrapper}>
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            {items.map((item, idx) => (<div className={`row ${styles['row-wrapper']}`}>
              <div className={`col-xs-7 ${styles['item-name-wrapper']}`}>
                <a href='#' onClick={(e) => this._onTextClick(e, item)}>{item.name}</a>
              </div>
              <div className={`col-xs-1 ${styles['item-name-wrapper']}`} />
              <div className={`col-xs-4 ${styles['item-checkbox-wrapper']}`}>
                <div className={`checkbox ${styles['checkbox-moka']}`}>
                  <input type='checkbox' checked={this._checked(item)} onChange={(e) => this._onChangeCheckbox(e, item)} />
                  <label />
                </div>
              </div>
            </div>))}
          </InfiniteScroll>
        </div>
      </div>)
    } else {
      return (<div className={styles['text-notif']}>
        No Items Found. Go to <a href='#' onClick={this._gotoLibraryItems}>items page</a> to manage items.
      </div>)
    }
  }

  _itemsAssigned = () => {
    const {taxAssignToItem: {itemIds}, taxDetail} = this.props
    // const {items} = this.props // the loaded items
    const categoryId = this.props.taxAssignToItem.category_id
    const keyword = this.props.taxAssignToItem.keyword
    if (!keyword && categoryId === 0) {
      return itemIds.length
    } else if (categoryId !== 0 && !keyword) {
      const temp = taxDetail.items.filter(item => item.category_id === categoryId) // make a copy
      const itemsAsId = _map(temp, 'item_id')
      return itemsAsId.length
    } else if (categoryId === 0 && !keyword) {
      const re = new RegExp(keyword, 'i')
      const temp = taxDetail.items.filter(item => {
        return item.name.search(re) !== -1
      }) // make a copy
      const itemsAsId = _map(temp, 'item_id')
      return itemsAsId.length
    } else { // have keyword & category
      const re = new RegExp(keyword, 'i')
      const temp = taxDetail.items.filter(item => item.category_id === categoryId && item.name.search(re) !== -1) // make a copy
      const itemsAsId = _map(temp, 'item_id')
      return itemsAsId.length
    }
  }

  _allChecked = (isAdd, itemId) => {
    const { dispatch } = this.props
    if (isAdd === false) {
      dispatch(uncheckSelectAllTaxItems())
    } else {
      const {taxAssignToItem: {itemIds}} = this.props
      const {items} = this.props // the loaded items
      const itemsAsId = _map(items, 'id')
      const temp = itemIds.filter(item => true) // make a copy of the array for temporary use

      if (itemId !== undefined) temp.push(itemId)

      const intersect = _intersection(itemsAsId, temp)
      if (intersect.length === itemsAsId.length) {
        dispatch(checkSelectAllTaxItems())
      } else {
        dispatch(uncheckSelectAllTaxItems())
      }
    }
  }

  _hasMore = () => {
    const {currentPage, totalPage} = this.props
    let ret = currentPage < totalPage
    return ret
  }

  _onReachBottom = () => {
    const {currentPage, totalPage, taxAssignToItem: {itemIds, keyword, category_id}, items, dispatch} = this.props
    if (currentPage < totalPage) {
      dispatch(taxAssignToItemItemsRequest({keyword, page: currentPage + 1, with_batch: true, categoryId: category_id, itemIds}, items))
    }
  }

  _selectAllNone = (e, selectAll) => {
    e.preventDefault()
    e.stopPropagation()
    const {taxAssignToItem: {itemIds, category_id, keyword}, dispatch, taxDetail, outletIds, setting} = this.props // the selected category or all
    let businessId = setting.business_id
    let outletId = outletIds[0]
    dispatch(taxAssignToItemSelectAllNone(businessId, outletId, taxDetail, itemIds, category_id, keyword, selectAll))
    if (selectAll) {
      dispatch(checkSelectAllTaxItems())
    } else {
      dispatch(uncheckSelectAllTaxItems())
    }
  }

  _onTextClick = (e, item) => {
    e.preventDefault()
    e.stopPropagation()
    const {taxAssignToItem: {itemIds}, dispatch, taxDetail} = this.props
    const found = itemIds.find(element => element === item.id)
    if (found === undefined) { // unchecked so add
      dispatch(taxAssignToItemToggleOne(taxDetail, item, true)) // add to taxDetail.items
      dispatch(arrayPush('taxAssignToItem', 'itemIds', item.id))
      this._allChecked(true, item.id)
    } else { // checked so remove
      const newItemIds = itemIds.filter(element => element !== item.id)
      dispatch(taxAssignToItemToggleOne(taxDetail, item, false)) // remove from taxDetail.items
      dispatch(change('taxAssignToItem', 'itemIds', newItemIds))
      this._allChecked(false, item.id)
    }
  }

  _onChangeCheckbox = (e, item) => {
    const {taxAssignToItem: {itemIds}, dispatch, taxDetail} = this.props
    const indexPositions = {}

    // find index of the item being checked / unchecked
    itemIds.forEach((itemId, index) => {
      if (itemId === item.id) {
        indexPositions[index] = true
      }
    })
    if (e.target.checked) {
      dispatch(taxAssignToItemToggleOne(taxDetail, item, true)) // add to taxDetail.items
      dispatch(arrayPush('taxAssignToItem', 'itemIds', item.id))
      this._allChecked(true, item.id)
    } else {
      // remove all if exists (don't know why server has more than one
      const newItemIds = []
      itemIds.forEach((itemId, index) => { // rebuild...
        if (!indexPositions[index]) {
          newItemIds.push(itemId)
        }
      })
      dispatch(taxAssignToItemToggleOne(taxDetail, item, false)) // remove from taxDetail.items
      dispatch(change('taxAssignToItem', 'itemIds', newItemIds))
      this._allChecked(false, item.id)
    }
  }

  _checked = (targetItem) => {
    const {taxAssignToItem: {itemIds}} = this.props
    let checked = false
    itemIds.forEach((itemId) => {
      checked = checked || (itemId === targetItem.id)
    })
    return checked
  }

  _gotoLibraryItems = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const {dispatch, taxDetail} = this.props
    const url = '/library/list'
    // close the modal, url decides if moving to another route, if empty, then no browserHistory.push is done
    dispatch(cancelTaxAssignToItem(taxDetail, url))
  }
}

const selector = formValueSelector('taxAssignToItem')

function mapStateToProps (state) {
  const {taxAssignToItems: {items, currentPage, totalPage}, taxDetail, checkSelectAllTaxItemsFlag, setting} = state.library.tax
/* Please leave this here for now
  const {outlets} = state.library.tax
  let outletIds = []
  if (outlets.length) {
    outletIds.push(outlets[0].id)
  }
  if (state.form.search.values !== undefined) {
    outletIds = state.form.search.values.outletIds
  }
*/
  const { outletIds } = state.form.search.values
  return {
    taxDetail,
    taxAssignToItem: {
      itemIds: selector(state, 'itemIds'),
      keyword: selector(state, 'keyword'),
      category_id: selector(state, 'category_id')
    },
    items,
    currentPage,
    totalPage,
    checkSelectAllTaxItemsFlag,
    outletIds,
    setting
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Items)

// applySetItem -> taxAssignToItem
// applySetItemItemsRequest -> taxAssignToItemItemsRequest



// WEBPACK FOOTER //
// ./app/pages/Library/Tax/TaxAssignToItemModal/Items/Items.js